import { useState } from 'react'
import { DropdownMenu } from 'radix-ui'
import { MoreVertical } from 'lucide-react'
import type { Board, BoardColumnDto } from '../types'
import { DeleteColumnDialog } from './DeleteColumnDialog'
import { EditColumnDialog } from './EditColumnDialog'

interface ColumnMenuProps {
  board: Board
  column: BoardColumnDto
}

/**
 * Dropdown menu (kropki) na nagłówku kolumny - rename + delete.
 * Add column jest na poziomie boardu (przycisk "+ Dodaj kolumnę" w KanbanBoard).
 *
 * Bierze cały Board (nie samo id) bo DeleteColumnDialog potrzebuje listy innych
 * kolumn dla move-cards-to picker, a działa zarówno dla personal jak i context boardu.
 */
export function ColumnMenu({ board, column }: ColumnMenuProps) {
  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)

  return (
    <>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <button
            type="button"
            className="p-1 rounded hover:bg-slate-200 text-slate-500"
            aria-label="Menu kolumny"
          >
            <MoreVertical className="w-4 h-4" />
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            sideOffset={4}
            className="bg-white shadow-md rounded border border-slate-200 py-1 text-sm z-50 min-w-[160px]"
          >
            <DropdownMenu.Item
              onSelect={() => setShowEdit(true)}
              className="px-3 py-1.5 hover:bg-slate-100 cursor-pointer outline-none"
            >
              Edytuj kolumnę
            </DropdownMenu.Item>
            <DropdownMenu.Item
              onSelect={() => setShowDelete(true)}
              className="px-3 py-1.5 hover:bg-slate-100 cursor-pointer outline-none text-red-600"
            >
              Usuń kolumnę
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>

      {showEdit && (
        <EditColumnDialog
          boardId={board.id}
          column={column}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showDelete && (
        <DeleteColumnDialog
          board={board}
          column={column}
          onClose={() => setShowDelete(false)}
        />
      )}
    </>
  )
}
